/* eslint-disable */

import { Component } from 'react';
import SendEmailModal from '../../components/Modals/SendEmailModal';
import Message from '../Message';
import { sendEmailQuery, sendEmailToAllUsersQuery } from './query';

class AdditionalBox extends Component {
    constructor() {
        super();
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.setMessage = this.setMessage.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.sendEmailToAllUsers = this.sendEmailToAllUsers.bind(this);

        this.state = {
            isOpen: false,
            message: '',
            message_tag: '',
            isLoading: false,
            isAllUsers: false,
        };
    }

    onOpenModal(isAllUsers) {
        this.setState({ isOpen: true, isAllUsers });
    }

    onCloseModal() {
        this.setState({ isOpen: false });
    }

    sendEmail(args) {
        const { closeModal, subject, body_text } = args;
        const emails = this.props.getEmails();
        if (!emails?.length) {
            this.onCloseModal();
            return this.setMessage('You need to select a user.', 'info');
        }

        this.setState({ isLoading: true });

        const params = { subject, body_text, emails };
        sendEmailQuery(params)
            .then((res) => res.json())
            .then((data) => {
                let message_tag = '';
                if (data.status === 200) message_tag = 'success';
                if (data.status === 400) message_tag = 'error';
                this.setMessage(data.message, message_tag);
            })
            .catch((err) => this.setMessage(err?.message, 'error'))
            .finally(() => {
                closeModal();
                this.props.onRemoveAllSelected();
                this.setState({ isLoading: false });
            });
    }

    sendEmailToAllUsers(args) {
        const { closeModal, subject, body_text } = args;

        this.setState({ isLoading: true });

        const params = { subject, body_text };

        sendEmailToAllUsersQuery(params)
            .then((res) => res.json())
            .then((data) => {
                let message_tag = '';
                if (data.status === 200) message_tag = 'success';
                if (data.status === 400) message_tag = 'error';
                this.setMessage(data.message, message_tag);
            })
            .catch((err) => this.setMessage(err?.message, 'error'))
            .finally(() => {
                closeModal();
                this.props.onRemoveAllSelected();
                this.setState({ isLoading: false });
            });
    }

    setMessage(message, message_tag) {
        this.setState({
            message,
            message_tag,
        });
    }

    deleteMessage() {
        this.setState({
            message: '',
            message_tag: '',
        });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="table-additional-view">
                    <div className="table-additional-view-btns">
                        <button
                            className={`table-additional-view-btn`}
                            onClick={() => this.onOpenModal(true)}
                        >
                            {t('customers.additional_box.send_email_to_all_users')}
                        </button>
                        <button
                            className={`table-additional-view-btn`}
                            onClick={() => this.onOpenModal(false)}
                        >
                            {t('customers.additional_box.send_email')}
                        </button>
                    </div>
                </div>
                <SendEmailModal
                    isOpen={this.state.isOpen}
                    onClose={this.onCloseModal}
                    onSubmit={this.state.isAllUsers ? this.sendEmailToAllUsers : this.sendEmail}
                    isLoading={this.state.isLoading}
                />
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tag}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
            </>
        );
    }
}

export default AdditionalBox;
